import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=6c0f620a&scoped=true&"
import script from "./PermissionsTable.vue?vue&type=script&lang=ts&"
export * from "./PermissionsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f620a",
  null
  
)

export default component.exports